// #region imports

// --- Angular
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

// --- HS Code
import { Constants } from '../../../models';
import { LanguageDomBaseService } from './language-dom-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class LanguageDomMockService extends LanguageDomBaseService {

  constructor(
    @Inject(DOCUMENT) document: Document) {
    super(document);
  }

  init(): void {
    this.onLangChange(Constants.DEFAULT_LANGUAGE, false);
  }
}
